import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PerfilSeccionEstado } from '../../../data/perfil-microempresario.content';

@Component({
  selector: 'app-perfil-section-card',
  templateUrl: './perfil-section-card.component.html',
  styleUrls: ['./perfil-section-card.component.scss'],
  standalone: false,
})
export class PerfilSectionCardComponent {
  @Input() titulo = '';
  @Input() icon: 'face' | 'store' | 'attach_money' = 'face';
  @Input() estado: PerfilSeccionEstado = 'pendiente';
  @Input() progreso = 0;
  /** Checkpoints visuales de la barra por sección (sin lógica de avance final). */
  @Input() checkpoints = 2;
  @Input() disabled = false;
  /** Empezar / Continuar / Editar (accesibilidad + desktop hover opcional). */
  @Input() actionLabel = '';
  /** Id de tracking GTM (HU 8099/8188 #21), p. ej. `btn-perfil-hub-sobre-ti`. */
  @Input() elementId = '';

  @Output() actionClick = new EventEmitter<void>();

  private readonly iconMap: Record<'face' | 'store' | 'attach_money', string> = {
    face: 'assets/img/perfil/icon-sobre-ti.svg',
    store: 'assets/img/perfil/icon-sobre-negocio.svg',
    attach_money: 'assets/img/perfil/icon-sobre-ingresos.svg',
  };

  get iconSrc(): string {
    return this.iconMap[this.icon] ?? this.iconMap.face;
  }

  get progresoClamped(): number {
    return Math.max(0, Math.min(100, this.progreso ?? 0));
  }

  get esCompleta(): boolean {
    return this.estado === 'completo' || this.progresoClamped >= 100;
  }

  get actionIconSrc(): string {
    return this.esCompleta
      ? 'assets/img/perfil/icon-edit.svg'
      : 'assets/img/perfil/icon-arrow.svg';
  }

  get ariaActionLabel(): string {
    const verb = this.actionLabel || (this.esCompleta ? 'Editar' : 'Ir a');
    return `${verb} ${this.titulo}`.trim();
  }

  onAction(): void {
    if (!this.disabled) {
      this.actionClick.emit();
    }
  }
}
